import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { debounce, debounceTime } from 'rxjs/operators';

@Component({
  selector: 'frg-search-input',
  templateUrl: './search-input.fragment.html',
  styleUrls: ['./search-input.fragment.scss']
})
export class SearchInputFragment implements OnInit {

  @Output()
  public search = new EventEmitter<string>();
  public searchSubject: Subject<any> = new Subject<any>();

  public searchInput = '';

  constructor() { }

  ngOnInit(): void {
    this.searchSubject.pipe(debounceTime(500)).subscribe(async (search) => {
      this.search.emit(this.searchInput);
    });
  }
  selectAll(event: FocusEvent) {
    const input = event.target as HTMLInputElement;
    input.select();
  }

}
